import React from 'react';
import messages from './interactionMessages';
import { AppointmentIcon, MailIcon, NoteIcon, PhoneIcon } from '@/shared/components/Icons';
const InteractionIcon = ({ intl, type }) => {
  switch (type) {
    case 0:
      return <NoteIcon tooltip={intl.formatMessage(messages.Note)} />;
    case 1:
      return <PhoneIcon tooltip={intl.formatMessage(messages.PhoneCall)} />;
    case 2:
      return <MailIcon tooltip={intl.formatMessage(messages.Email)} />;
    case 3:
      return <AppointmentIcon tooltip={intl.formatMessage(messages.Appointment)} />;
    default:
      return <NoteIcon tooltip={intl.formatMessage(messages.Note)} />;
  }
};

export default React.memo(InteractionIcon);
